module.exports = __webpack_public_path__ + "images/emoji/scream.5d17b360cd226efffedf.png";